import React from "react";
import HiddenBox from "./HiddenBox";

export default class InnerBox extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            visible: false
        };
        console.log(props.topicId);
        
    }
    handleClick() {
      this.setState((prevState) => {
          return {
              visible: !prevState.visible
          };
      });
  }
  

  render() {
    return (
      <div>
                <button type="button" class="btn bg-light btn-lg btn-block mb-1 py-1" onClick={this.handleClick}>
                    {(this.state.visible) ? "click to HIDE major influencers for this topic." : "click to SHOW major influencers for this topic."}
                </button>
                {(this.state.visible) && <HiddenBox topicId={this.props.topicId}/>}
            </div>

    );
  }
}



// import React from "react";
// import HiddenBox from "./HiddenBox";

// import {
//   CardBody,
//   Row, 

// } from "shards-react";

// export default class InnerBox extends React.Component {
//     constructor(props) {
//         super(props);
//         this.handleClick = this.handleClick.bind(this);
//         this.state = {
//             visible: false
//         };
//         console.log(props.topicId);
        
//     }
//     handleClick() {
//       this.setState((prevState) => {
//           return {
//               visible: !prevState.visible
//           };
//       });
//   }
  

//   render() {
//     return (
//       <div>
//                 <h1>Visibility Toggle</h1>
//                 <button onClick={this.handleClick}>
//                     {(this.state.visible) ? "Hide Details" : "Show Details"}
//                 </button>
                

//                 <p>
//                     {(this.state.visible) ? "Hey, This is some text" : ""}
//                 </p>
//                 {(this.state.visible) && <HiddenBox topicId={this.props.topicId}/>}
//             </div>

//     );
//   }
// }






// import React from "react";
// import HiddenBox from "./HiddenBox";

// import {
//   CardBody,
//   Row, 

// } from "shards-react";

// export default class InnerBox extends React.Component {
//     constructor(props) {
//         super(props);
//         console.log(props.topicId);
        
//     }

//   state = {
//     buttonClicked: false
//   };
//   handleClick = () => {
//     this.setState({
//       buttonClicked: !this.state.buttonClicked
//     });
//   };
//   render() {
//     return (
//       // <CardBody> 
//       <row className="mt-0" onDoubleClick={this.handleClick}>
//         {this.props.children}
//         {(this.state.buttonClicked ) && <HiddenBox topicId={this.props.topicId}/>}
        
//       </row>
      

//       // </CardBody> 
//     );
//   }
// }
